import styled from 'styled-components';
import { Button } from "react-bootstrap";

interface IBannerPrimaryButtonStyledProps {
    background?: string;
}

export const BannerPrimaryButtonStyled = styled(Button)<IBannerPrimaryButtonStyledProps>`
    &.btn.btn-primary {
        &, &:hover, &:active, &:focus {
            border: none;
            background: ${({background}) => background || 'var(--color-neutral-10)'};
        }
    }
`;
